import React, { Fragment, useState } from 'react';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';





const Formulario = ({ newCita }) => {
    //Crear el state de las citas
    const [ cita, setCita] = useState({
        mascota: '',
        propietario: '',
        fecha: '',
        hora: '',
        sintomas: ''
    });
    const [ error, setError ] = useState(false)



    const handleChange = e => {
        setCita({
            // Se toma una compia del state para no sobreescribir los datos del objeto.
            ...cita,
            [e.target.name]: e.target.value
        })
    }

    const submitcita = e => {
        e.preventDefault();

        //validacion para que los campos no se envien vacios
        if(mascota.trim() === ''  || propietario.trim() === '' || fecha.trim() === '' ||
        hora.trim() === '' || sintomas.trim() === '') {
            setError(true);
            return;
        }

        //Insertar ID
        cita.id = uuid();

        //Crear cita
        newCita(cita);

        //Reiniciar formulario
        setCita({
            mascota: '',
            propietario: '',
            fecha: '',
            hora: '',
            sintomas: ''
        });
        setError(false);

    }

    const { mascota, propietario, fecha, hora, sintomas } = cita;


    return (
        <Fragment>
            <h2>Crear cita</h2>

            { error ? <p>Todos los campos son obligatorios</p> : null }

            <form onSubmit={submitcita} className="form">
                <div className="form__body">
                    <label htmlFor="mascota">Nombre mascota</label>
                    <input
                        type="text"
                        name="mascota"
                        className="input"
                        placeholder="Nombre de mascota"
                        id="mascota"
                        onChange={handleChange}
                        value={mascota}/>
                </div>

                <div className="form__body">
                    <label htmlFor="propietario">Nombre del dueño</label>
                    <input
                        type="text"
                        name="propietario"
                        className="input"
                        placeholder="Nombre del dueño"
                        id="propietario"
                        onChange={handleChange}
                        value={propietario}/>
                </div>

                <div className="form__body">
                    <label htmlFor="fecha">Fecha</label>
                    <input
                        type="date"
                        name="fecha"
                        className="input"
                        id="fecha"
                        onChange={handleChange}
                        value={fecha}/>
                </div>

                <div className="form__body">
                    <label htmlFor="hora">Hora</label>
                    <input
                        type="time"
                        name="hora"
                        className="input"
                        id="hora"
                        onChange={handleChange}
                        value={hora}/>
                </div>

                <div className="form__body">
                    <label htmlFor="sintomas">Sintomas</label>
                    <textarea
                        name="sintomas"
                        className="textarea"
                        id="sintomas"
                        onChange={handleChange}
                        value={sintomas}>
                    </textarea>
                </div>

                <button type="submit" className="btn">
                    Agrega cita
                </button>
            </form>
        </Fragment>
    );
}
Formulario.propTypes = {
    newCita: PropTypes.func.isRequired
}

export default Formulario;